<template>
  <section class="ai-welcome">
    <header class="ai-welcome__heading">
      <h1>{{ title }}</h1>
      <p v-if="showDescription">{{ description }}</p>
    </header>

    <div v-if="showModeSwitch" class="ai-mode-switch" role="radiogroup">
      <button
        type="button"
        :class="{ 'is-active': mode === 'ai', 'ai-mode-btn':true }"
        @click="$emit('update:mode', 'ai')"
      >
        <CustomImg :src="aiIcon" alt="" />
        {{ t('ai.mode.ai') }}
      </button>
      <button
        type="button"
        :class="{ 'is-active': mode === 'regular', 'ai-mode-btn':true }"
        @click="$emit('regular-search')"
      >
        <CustomImg :src="searchIcon" alt="" />
        {{ t('ai.mode.regular') }}
      </button>
    </div>

  </section>
</template>

<script setup lang="ts">
import CustomImg from '@/components/CustomImg.vue';
import aiIcon from '@/assets/images/ai/icon1-1.svg';
import searchIcon from '@/assets/images/ai/icon2.svg';
import type { SearchMode, Translate } from './types';

defineProps<{
  t: Translate;
  mode: SearchMode;
  title: string;
  description: string;
  showDescription?: boolean;
  showModeSwitch?: boolean;
}>();

defineEmits<{
  'update:mode': [value: SearchMode];
  'regular-search': [];
}>();
</script>

<style scoped lang="scss">
.ai-welcome {
  position: relative;
  width: min(1000px, 100%);
  margin: 0 auto;
  text-align: center;
}

.ai-welcome__heading {
  width: min(850px, 100%);
  margin: 0 auto;

  h1 {
    margin: 0;
    color: #000;
    font-size: clamp(44px, 4vw, 60px);
    font-weight: 800;
    line-height: 1.15;
  }

  p {
    margin: 12px 0 0;
    color: #333;
    font-size: clamp(18px, 1.5vw, 22px);
    line-height: 1.55;
  }
}

.ai-mode-switch {
  display: inline-flex;
  margin-top: 24px;
  padding: 5px;
  border-radius: 999px;
  background: #fff;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 240px;
    height: 50px;
    padding: 0 20px;
    border: 0;
    border-radius: 999px;
    color: #666;
    background: transparent;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: .3s;

    &.is-active,
    &:hover {
      color: #000;
      background: #f5f5f5;
    }

    img {
      width: 21px;
      margin-right: 16px;
    }
  }
}

@media (max-width: 900px) {
  .ai-mode-switch button { min-width: 200px; }
}

@media (max-width: 600px) {
  .ai-welcome__heading h1 { font-size: 38px; }
  .ai-welcome__heading p { font-size: 15px; }

  .ai-mode-switch {
    display: flex;
    width: 100%;

    button {
      flex: 1;
      min-width: 0;
      height: 44px;
      padding: 0 10px;
      font-size: 14px;

      img {
        width: 16px;
        margin-right: 7px;
      }
    }
  }

}
</style>
